import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_112: FaireProductEntity = {
  token: "legacy_prod_abbott-112",
  type: "product",
  name: "Beehive Covered Pot",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/2b39d78932ebab5cd3cd837bb7cfb4a7ef7914959d86639fe11df533b2a67e94.jpeg",
  priceDollars: 22,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
